import axios from 'axios';

import _ from 'scbk-services/utils/lodash-extension.ts';

import type { AxiosInstance } from 'axios';

class AxiosInstanceManager {
    private static commonInstance: AxiosInstance;
    private static assetInstance: AxiosInstance;

    private constructor() {}

    public static getCommonAxiosInstance = (baseUrl: string): AxiosInstance => {
        if (_.isEmpty(this.commonInstance)) {
            this.commonInstance = axios.create({
                withCredentials: true,
                baseURL: baseUrl,
                timeout: 150 * 1000,
            });
        }

        // Update base URL every time when the instance is been called
        // As in some case, we may need to use different base URL for different request in same app
        this.commonInstance.defaults.baseURL = baseUrl;

        return this.commonInstance;
    };

    public static getAssetAxiosInstance = (baseUrl: string): AxiosInstance => {
        if (_.isEmpty(this.assetInstance)) {
            this.assetInstance = axios.create({
                withCredentials: false,
                baseURL: baseUrl,
                timeout: 150 * 1000,
            });
        }

        // Update base URL every time when the instance is called
        // As in some case, we may need to use different base URL for different request in same app
        this.assetInstance.defaults.baseURL = baseUrl;

        return this.assetInstance;
    };
}

export { AxiosInstanceManager };
